import { Pipe, PipeTransform} from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
@Pipe({name: 'start'})
export class Start implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(value: number): SafeHtml  {
    let res = '';
    switch (true) {
      case value >= 1 && value < 1.5: {
        res =
        '<li class="list-inline-item"><i class="fa fa-star"></i></li>'+
        '<li class="list-inline-item"><i class="fa fa-star-o"></i></li>'+
        '<li class="list-inline-item"><i class="fa fa-star-o"></i></li>'+
        '<li class="list-inline-item"><i class="fa fa-star-o"></i></li>'+
        '<li class="list-inline-item"><i class="fa fa-star-o"></i></li>';
        return this.sanitizer.bypassSecurityTrustHtml(res);
      }
      case value >= 1.5 && value < 2: {
        res =
          '<li class="list-inline-item"><i class="fa fa-star"></i></li>'+
          '<li class="list-inline-item"><i class="fa fa-star-half-empty"></i></li>'+
          '<li class="list-inline-item"><i class="fa fa-star-o"></i></li>'+
          '<li class="list-inline-item"><i class="fa fa-star-o"></i></li>'+
          '<li class="list-inline-item"><i class="fa fa-star-o"></i></li>';
        return this.sanitizer.bypassSecurityTrustHtml(res);
      }
      case value >= 2 && value < 2.5: {
        res =
        '<li class="list-inline-item"><i class="fa fa-star"></i></li>'+
        '<li class="list-inline-item"><i class="fa fa-star"></i></li>'+
        '<li class="list-inline-item"><i class="fa fa-star-o"></i></li>'+
        '<li class="list-inline-item"><i class="fa fa-star-o"></i></li>'+
        '<li class="list-inline-item"><i class="fa fa-star-o"></i></li>';
        return this.sanitizer.bypassSecurityTrustHtml(res);
      }
      case value >= 2.5 && value < 3: {
        res =
          '<li class="list-inline-item"><i class="fa fa-star"></i></li>'+
          '<li class="list-inline-item"><i class="fa fa-star"></i></li>'+
          '<li class="list-inline-item"><i class="fa fa-star-half-empty"></i></li>'+
          '<li class="list-inline-item"><i class="fa fa-star-o"></i></li>'+
          '<li class="list-inline-item"><i class="fa fa-star-o"></i></li>';
        return this.sanitizer.bypassSecurityTrustHtml(res);
      }
      case value >= 3 && value < 3.5: {
        res =
        '<li class="list-inline-item"><i class="fa fa-star"></i></li>'+
        '<li class="list-inline-item"><i class="fa fa-star"></i></li>'+
        '<li class="list-inline-item"><i class="fa fa-star"></i></li>'+
        '<li class="list-inline-item"><i class="fa fa-star-o"></i></li>'+
        '<li class="list-inline-item"><i class="fa fa-star-o"></i></li>';
        return this.sanitizer.bypassSecurityTrustHtml(res);
      }
      case value >= 3.5 && value < 4: {
        res =
          '<li class="list-inline-item"><i class="fa fa-star"></i></li>'+
          '<li class="list-inline-item"><i class="fa fa-star"></i></li>'+
          '<li class="list-inline-item"><i class="fa fa-star"></i></li>'+
          '<li class="list-inline-item"><i class="fa fa-star-half-empty"></i></li>'+
          '<li class="list-inline-item"><i class="fa fa-star-o"></i></li>';
        return this.sanitizer.bypassSecurityTrustHtml(res);
      }
      case value >= 4 && value < 4.5: {
        res =
        '<li class="list-inline-item"><i class="fa fa-star"></i></li>'+
        '<li class="list-inline-item"><i class="fa fa-star"></i></li>'+
        '<li class="list-inline-item"><i class="fa fa-star"></i></li>'+
        '<li class="list-inline-item"><i class="fa fa-star"></i></li>'+
        '<li class="list-inline-item"><i class="fa fa-star-o"></i></li>';
        return this.sanitizer.bypassSecurityTrustHtml(res);
      }
      case value >= 4.5 && value < 4.9: {
        res =
          '<li class="list-inline-item"><i class="fa fa-star"></i></li>'+
          '<li class="list-inline-item"><i class="fa fa-star"></i></li>'+
          '<li class="list-inline-item"><i class="fa fa-star"></i></li>'+
          '<li class="list-inline-item"><i class="fa fa-star"></i></li>'+
          '<li class="list-inline-item"><i class="fa fa-star-half-empty"></i></li>';
        return this.sanitizer.bypassSecurityTrustHtml(res);
      }
      case value >= 4.9 && value < 5: {
        res =
          '<li class="list-inline-item"><i class="fa fa-star"></i></li>'+
          '<li class="list-inline-item"><i class="fa fa-star"></i></li>'+
          '<li class="list-inline-item"><i class="fa fa-star"></i></li>'+
          '<li class="list-inline-item"><i class="fa fa-star"></i></li>'+
          '<li class="list-inline-item"><i class="fa fa-star"></i></li>';
        return this.sanitizer.bypassSecurityTrustHtml(res);
      }
      default: {
        res =
        '<li class="list-inline-item"><i class="fa fa-star"></i></li>'+
        '<li class="list-inline-item"><i class="fa fa-star"></i></li>'+
        '<li class="list-inline-item"><i class="fa fa-star"></i></li>'+
        '<li class="list-inline-item"><i class="fa fa-star"></i></li>'+
        '<li class="list-inline-item"><i class="fa fa-star"></i></li>';
        return this.sanitizer.bypassSecurityTrustHtml(res);
      }
    }
  }
}
